import * as XLSX from "xlsx";

export const formatExcelDate = (value) => {
  if (!value) return "";

  if (value instanceof Date && !isNaN(value.getTime())) {
    return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(value.getDate()).padStart(2, "0")}`;
  }

  if (typeof value === "string" && value.includes("-")) {
    return value;
  }

  if (typeof value === "string" && value.includes("/")) {
    const parts = value.split("/");

    if (parts.length !== 3) {
      return "";
    }

    const [day, month, year] = parts;

    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  if (typeof value === "string" && value.includes(".")) {
    const parts = value.split(".");

    if (parts.length !== 3) {
      return "";
    }

    const [day, month, year] = parts;

    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  const numericValue = Number(value);

  if (!isNaN(numericValue) && numericValue > 30000) {
    const date = XLSX.SSF.parse_date_code(numericValue);

    if (!date) {
      return "";
    }

    return `${date.y}-${String(date.m).padStart(2, "0")}-${String(
      date.d
    ).padStart(2, "0")}`;
  }

  return "";
};

export const displayDate = (value) => {
  if (!value) return "";

  const dateValue = String(value);

  if (!dateValue.includes("-")) {
    return dateValue;
  }

  const [year, month, day] = dateValue.split("-");

  return `${day}.${month}.${year}`;
};

export const dateInputValue = (value) => {
  if (!value) return "";

  if (value.includes("-")) {
    return value;
  }

  if (value.includes(".")) {
    const [day, month, year] = value.split(".");

    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }

  return "";
};

export const parseProjectDate = (value) => {
  if (!value) return null;

  const text = String(value);

  if (text.includes("-")) {
    const date = new Date(text);

    return isNaN(date.getTime()) ? null : date;
  }

  if (text.includes(".")) {
    const [day, month, year] = text.split(".");

    const date = new Date(
      Number(year),
      Number(month) - 1,
      Number(day)
    );

    return isNaN(date.getTime()) ? null : date;
  }

  return null;
};

export const getKalanAyNumber = (project) => {
  if (project?.projeStbKodu?.toUpperCase() === "DB") {
    return null;
  }

  if (project?.sonlandirmaTarihi) {
    return null;
  }

  const hedefTarih =
    project?.ekSureTarihi || project?.bitisTarihi;

  const endDate = parseProjectDate(hedefTarih);

  if (!endDate) {
    return null;
  }

  const today = new Date();

  today.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  return Math.floor(
    (endDate - today) / (1000 * 60 * 60 * 24)
  );
};

export const calculateKalanAySureForProject = (project) => {
  if (project?.projeStbKodu?.toUpperCase() === "DB") {
    return "Değerlendirme Bekleyen Proje";
  }

  if (project?.sonlandirmaTarihi) {
    if (project?.projeBitirmeBelgesi === "Var") {
      return "Proje sonlandırılmıştır";
    }

    return "Proje Bitirme Belgesi alınacak";
  }

  const hedefTarih =
    project?.ekSureTarihi || project?.bitisTarihi;

  const endDate = parseProjectDate(hedefTarih);

  if (!endDate) {
    return "";
  }

  const today = new Date();

  today.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  let months =
    (endDate.getFullYear() - today.getFullYear()) * 12 +
    (endDate.getMonth() - today.getMonth());

  let tempDate = new Date(today);

  tempDate.setMonth(tempDate.getMonth() + months);

  if (tempDate > endDate) {
    months -= 1;

    tempDate = new Date(today);

    tempDate.setMonth(tempDate.getMonth() + months);
  }

  const diffMs = endDate - tempDate;

  const days = Math.floor(
    diffMs / (1000 * 60 * 60 * 24)
  );

  const totalDiffDays = Math.floor(
    (endDate - today) / (1000 * 60 * 60 * 24)
  );

  if (totalDiffDays < 0) {
    const gecikenGun = Math.abs(totalDiffDays);

    const gecikenAy = Math.floor(gecikenGun / 30);

    const kalanGun = gecikenGun % 30;

    return `${gecikenAy} ay ${kalanGun} gün gecikti`;
  }

  return `${months} ay ${days} gün`;
};

export const calculateProjeSuresiForProject = (project) => {
  const startDate = parseProjectDate(
    project?.baslangicTarihi
  );

  const endDate = parseProjectDate(
    project?.ekSureTarihi || project?.bitisTarihi
  );

  if (!startDate || !endDate) {
    return "";
  }

  const yearDiff =
    endDate.getFullYear() - startDate.getFullYear();

  const monthDiff =
    endDate.getMonth() - startDate.getMonth();

  const toplamAy = yearDiff * 12 + monthDiff;

  if (toplamAy < 0) {
    return "";
  }

  return `${toplamAy} ay`;
};

export const getProjectStatusBadge = (project) => {
  const kalanGun = getKalanAyNumber(project);

  if (project?.projeStbKodu?.toUpperCase() === "DB") {
    return {
      text: "DB",
      background: "#e0f2fe",
      color: "#075985"
    };
  }

  if (kalanGun !== null && kalanGun < 0) {
    return {
      text: "Kritik",
      background: "#fee2e2",
      color: "#991b1b"
    };
  }

  if (kalanGun !== null && kalanGun <= 90) {
    return {
      text: "Riskli",
      background: "#fef3c7",
      color: "#92400e"
    };
  }

  return {
    text: "Stabil",
    background: "#dcfce7",
    color: "#166534"
  };
};

export const getKalanSureBadgeStyle = (project) => {
  const kalanAy = getKalanAyNumber(project);

  if (kalanAy === null) {
    return {
      background: "#f3f4f6",
      color: "#374151"
    };
  }

  if (kalanAy < 0) {
    return {
      background: "#fee2e2",
      color: "#991b1b"
    };
  }

  if (kalanAy <= 30) {
    return {
      background: "#ffedd5",
      color: "#9a3412"
    };
  }

  if (kalanAy <= 90) {
    return {
      background: "#fef3c7",
      color: "#92400e"
    };
  }

  return {
    background: "#dcfce7",
    color: "#166534"
  };
};
